import axios, { AxiosRequestConfig } from 'axios'

import { get, put } from './inner-store'
import { INNER_STORE } from './constants'
import { iAuthResponse } from './types'

export type Irefresh = () => Promise<iAuthResponse>

const refresh: Irefresh = async () => {
  const auth = get(INNER_STORE.auth)
  const scope = get(INNER_STORE.scope)
  const body = {
    grant_type: 'refresh_token',
    refresh_token: auth.refresh_token,
    client_id: get(INNER_STORE.client_id),
    ...(scope !== undefined ? { scope } : undefined),
  }
  const config: AxiosRequestConfig = {
    method: 'post',
    url: get(INNER_STORE.authServerTokenUri),
    data: new URLSearchParams(body as any).toString(),
  }

  const axiosInstance = axios.create({
    withCredentials: true,
  })

  const { data: refreshAuthData } =
    await axiosInstance.request<iAuthResponse>(config)

  put(INNER_STORE.auth, { ...refreshAuthData, isAuthenticated: true })

  return refreshAuthData
}

export { refresh }
